import { render, staticRenderFns } from "./OrderDetailRow.vue?vue&type=template&id=fa76ff16&scoped=true&"
import script from "./OrderDetailRow.vue?vue&type=script&lang=js&"
export * from "./OrderDetailRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailRow.vue?vue&type=style&index=0&id=fa76ff16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa76ff16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
